const mtr_line_en = {
    'AEL': 'Airport Express Line',
    'TCL': 'Tung Chung Line',
    'TML': 'Tuen Ma Line',
    'TKL': 'Tseung Kwan O Line',
    'EAL': 'East Rail Line',
    'SIL': 'South Island Line',
    'TWL': 'Tsuen Wan Line',
    'ISL': 'Island Line',
    'KTL': 'Kwun Tong Line',
};

const mtr_line_cn = {
    'AEL': '机场快线',
    'TCL': '东涌线',
    'TML': '屯马线',
    'TKL': '将军澳线',
    'EAL': '东铁线',
    'SIL': '南港岛线',
    'TWL': '荃湾线',
    'ISL': '港岛线',
    'KTL': '观塘线',
};

const mtr_sta_en = {
    'AEL': {
        'HOK': 'Hong Kong',
        'KOW': 'Kowloon',
        'TSY': 'Tsing Yi',
        'AIR': 'Airport',
        'AWE': 'AsiaWorld Expo'
    },
    'TCL': {
        'HOK': 'Hong Kong',
        'KOW': 'Kowloon',
        'OLY': 'Olympic',
        'NAC': 'Nam Cheong',
        'LAK': 'Lai King',
        'TSY': 'Tsing Yi',
        'SUN': 'Sunny Bay',
        'TUC': 'Tung Chung'
    },
    'TML': {
        'WKS': 'Wu Kai Sha',
        'MOS': 'Ma On Shan',
        'HEO': 'Heng On',
        'TSH': 'Tai Shui Hang',
        'SHM': 'Shek Mun',
        'CIO': 'City One',
        'STW': 'Sha Tin Wai',
        'CKT': 'Che Kung Temple',
        'TAW': 'Tai Wai',
        'HIK': 'Hin Keng',
        'DIH': 'Diamond Hill',
        'KAT': 'Kai Tak',
        'SUW': 'Sung Wong Toi',
        'TKW': 'To Kwa Wan',
        'HOM': 'Ho Man Tin',
        'HUH': 'Hung Hom',
        'ETS': 'East Tsim Sha Tsui',
        'AUS': 'Austin',
        'NAC': 'Nam Cheong',
        'MEF': 'Mei Foo',
        'TWW': 'Tsuen Wan West',
        'KSR': 'Kam Sheung Road',
        'YUL': 'Yuen Long',
        'LOP': 'Long Ping',
        'TIS': 'Tin Shui Wai',
        'SIH': 'Siu Hong',
        'TUM': 'Tuen Mun'
    },
    'TKL': {
        'NOP': 'North Point',
        'QUB': 'Quarry Bay',
        'YAT': 'Yau Tong',
        'TIK': 'Tiu Keng Leng',
        'TKO': 'Tseung Kwan O',
        'LHP': 'LOHAS Park',
        'HAH': 'Hang Hau',
        'POA': 'Po Lam',
    },
    'EAL': {
        'ADM': 'Admiralty',
        'EXC': 'Exhibition Centre',
        'HUH': 'Hung Hom',
        'MKK': 'Mong Kok East',
        'KOT': 'Kowloon Tong',
        'TAW': 'Tai Wai',
        'SHT': 'Sha Tin',
        'FOT': 'Fo Tan',
        'RAC': 'Racecourse',
        'UNI': 'University',
        'TAP': 'Tai Po Market',
        'TWO': 'Tai Wo',
        'FAN': 'Fanling',
        'SHS': 'Sheung Shui',
        'LOW': 'Lo Wu',
        'LMC': 'Lok Ma Chau',
    },
    'SIL': {
        'ADM': 'Admiralty',
        'OCP': 'Ocean Park',
        'WCH': 'Wong Chuk Hang',
        'LET': 'Lei Tung',
        'SOH': 'South Horizons',
    },
    'TWL': {
        'CEN': 'Central',
        'ADM': 'Admiralty',
        'TST': 'Tsim Sha Tsui',
        'JOR': 'Jordan',
        'YMT': 'Yau Ma Tei',
        'MOK': 'Mong Kok',
        'PRE': 'Price Edward',
        'SSP': 'Sham Shui Po',
        'CSW': 'Cheung Sha Wan',
        'LCK': 'Lai Chi Kok',
        'MEF': 'Mei Foo',
        'LAK': 'Lai King',
        'KWF': 'Kwai Fong',
        'KWH': 'Kwai Hing',
        'TWH': 'Tai Wo Hau',
        'TSW': 'Tsuen Wan',
    },
    'ISL': {
        'KET': 'Kennedy Town',
        'HKU': 'HKU',
        'SYP': 'Sai Ying Pun',
        'SHW': 'Sheung Wan',
        'CEN': 'Central',
        'ADM': 'Admiralty',
        'WAC': 'Wan Chai',
        'CAB': 'Causeway Bay',
        'TIH': 'Tin Hau',
        'FOH': 'Fortress Hill',
        'NOP': 'North Point',
        'QUB': 'Quarry Bay',
        'TAK': 'Tai Koo',
        'SWH': 'Sai Wan Ho',
        'SKW': 'Shau Kei Wan',
        'HFC': 'Heng Fa Chuen',
        'CHW': 'Chai Wan',

    },
    'KTL': {
        'WHA': 'Whampoa',
        'HOM': 'Ho Man Tin',
        'YMT': 'Yau Ma Tei',
        'MOK': 'Mong Kok',
        'PRE': 'Prince Edward',
        'SKM': 'Shek Kip Mei',
        'KOT': 'Kowloon Tong',
        'LOF': 'Lok Fu',
        'WTS': 'Wong Tai Sin',
        'DIH': 'Diamond Hill',
        'CHH': 'Choi Hung',
        'KOB': 'Kowloon Bay',
        'NTK': 'Ngau Tau Kok',
        'KWT': 'Kwun Tong',
        'LAT': 'Lam Tin',
        'YAT': 'Yau Tong',
        'TIK': 'Tiu Keng Leng',
    }
}

const mtr_sta_cn = {
    'AEL': {
        'HOK': '香港',
        'KOW': '九龙',
        'TSY': '青衣',
        'AIR': '机场',
        'AWE': '亚洲国际博览馆'
    },
    'TCL': {
        'HOK': '香港',
        'KOW': '九龙',
        'OLY': '奥运',
        'NAC': '南昌',
        'LAK': '荔景',
        'TSY': '青衣',
        'SUN': '欣澳',
        'TUC': '东涌'
    },
    'TML': {
        'WKS': '乌溪沙',
        'MOS': '马鞍山',
        'HEO': '恒安',
        'TSH': '大水坑',
        'SHM': '石门',
        'CIO': '第一城',
        'STW': '沙田围',
        'CKT': '车公庙',
        'TAW': '大围',
        'HIK': '显径',
        'DIH': '钻石山',
        'KAT': '启德',
        'SUW': '宋皇台',
        'TKW': '土瓜湾',
        'HOM': '何文田',
        'HUH': '红磡',
        'ETS': '尖东',
        'AUS': '柯士甸',
        'NAC': '南昌',
        'MEF': '美孚',
        'TWW': '荃湾西',
        'KSR': '锦上路',
        'YUL': '元朗',
        'LOP': '朗屏',
        'TIS': '天水围',
        'SIH': '兆康',
        'TUM': '屯门'
    },
    'TKL': {
        'NOP': '北角',
        'QUB': '鲗鱼涌',
        'YAT': '油塘',
        'TIK': '调景岭',
        'TKO': '将军澳',
        'LHP': '康城',
        'HAH': '坑口',
        'POA': '宝琳',
    },
    'EAL': {
        'ADM': '金钟',
        'EXC': '会展',
        'HUH': '红磡',
        'MKK': '旺角东',
        'KOT': '九龙塘',
        'TAW': '大围',
        'SHT': '沙田',
        'FOT': '火炭',
        'RAC': '马场',
        'UNI': '大学',
        'TAP': '大埔墟',
        'TWO': '太和',
        'FAN': '粉岭',
        'SHS': '上水',
        'LOW': '罗湖',
        'LMC': '落马洲',
    },
    'SIL': {
        'ADM': '金钟',
        'OCP': '海洋公园',
        'WCH': '黄竹坑',
        'LET': '利东',
        'SOH': '海怡半岛',
    },
    'TWL': {
        'CEN': '中环',
        'ADM': '金钟',
        'TST': '尖沙咀',
        'JOR': '佐敦',
        'YMT': '油麻地',
        'MOK': '旺角',
        'PRE': '太子',
        'SSP': '深水埗',
        'CSW': '长沙湾',
        'LCK': '荔枝角',
        'MEF': '美孚',
        'LAK': '荔景',
        'KWF': '葵芳',
        'KWH': '葵兴',
        'TWH': '大窝口',
        'TSW': '荃湾',
    },
    'ISL': {
        'KET': '坚尼地城',
        'HKU': '香港大学',
        'SYP': '西营盘',
        'SHW': '上环',
        'CEN': '中环',
        'ADM': '金钟',
        'WAC': '湾仔',
        'CAB': '铜锣湾',
        'TIH': '天后',
        'FOH': '炮台山',
        'NOP': '北角',
        'QUB': '鲗鱼涌',
        'TAK': '太古',
        'SWH': '西湾河',
        'SKW': '筲箕湾',
        'HFC': '杏花邨',
        'CHW': '柴湾',

    },
    'KTL': {
        'WHA': '黄埔',
        'HOM': '何文田',
        'YMT': '油麻地',
        'MOK': '旺角',
        'PRE': '太子',
        'SKM': '石硖尾',
        'KOT': '九龙塘',
        'LOF': '乐富',
        'WTS': '黄大仙',
        'DIH': '钻石山',
        'CHH': '彩虹',
        'KOB': '九龙湾',
        'NTK': '牛头角',
        'KWT': '观塘',
        'LAT': '蓝田',
        'YAT': '油塘',
        'TIK': '调景岭',
    }
}

const mtr_name = {
    'cn': [mtr_line_cn, mtr_sta_cn],
    'en': [mtr_line_en, mtr_sta_en],
}

export default mtr_name;